import { RouterProvider } from "@tanstack/react-router"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"

import { router } from "./app/router"
// Шрифт пакетом, а не ссылкой на Google Fonts, и это не вкус.
// Во-первых, плотность сетки дня меряна в Montserrat: пороги карточки 20/34/48 px,
// две буквы иконочной навигации, проверка «текст +40 %» — всё это метрики шрифта,
// и подстановка system-ui молча ломает приёмку у салона, у которого Montserrat
// не установлен. Во-вторых, внешний шрифт — это запрос к чужому домену с каждой
// загрузки кабинета: недоступность Google в РФ и утечка адреса салона в чужие логи.
import "@fontsource-variable/montserrat/wght.css"
import "./styles/tokens.css"
import "./styles/base.css"
import { registerOfflineCache } from "./offline/register"
import { syncThemeAttribute } from "./theme/theme"

// Скрипт в index.html уже поставил тему до первой отрисовки; это повтор на случай,
// когда разметку отдаёт не index.html (тесты, встроенный просмотр).
syncThemeAttribute()

const container = document.getElementById("root")
if (container === null) throw new Error("не найден корневой узел #root")

/*
 * ОФЛАЙН-ЧТЕНИЕ (П1-12, решение владельца 47). Подключается ДО первой отрисовки, но сам
 * работник регистрируется после загрузки страницы и только в собранном приложении:
 * в разработке он перехватывал бы модули Vite и ломал горячую перезагрузку. Проверки
 * внутри, поэтому здесь ни условий, ни try/catch.
 */
registerOfflineCache()

createRoot(container).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
)
